import { getCall, postCall, deleteCall, putCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getVariables = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/slots/" + bot_id);
  if (res[0]) {
    return res[0].slots;
  } else return null;
};

export const getFormBranchesSlots = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/slots/candidates/" + bot_id);
  if (res[0]) {
    return res[0].slot_candidates;
  } else return null;
};

export const addNewVariable = async (newVariable) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/slots/" + bot_id, newVariable);
  if (res[0]?.new_slot) {
    updateToast(id, "success", "Variable creada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al crear la variable.");
    return null;
  }
};

export const deleteVariable = async (variable_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/slots/" + bot_id + "/" + variable_id);
  if (res[0]) {
    updateToast(id, "success", "Variable eliminada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al eliminar la Variable.");
    return null;
  }
};

export const updateVariable = async (variable_id, updatedVariable) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/slots/" + bot_id + "/" + variable_id, updatedVariable);
  if (res[0]?.edited_slot) {
    updateToast(id, "success", "Variable actualizada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al actualizar la variable.");
    return null;
  }
};

// =========== VALUES =========== //
export const getValues = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/slots/values/" + bot_id);
  if (res[0]) {
    return res[0].slot_values;
  } else return null;
};

export const updateValue = async (updatedValue) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/slots/values/" + bot_id + "/" + updatedValue.slot_value_id, updatedValue);
  if (res[0]?.slot_value) {
    updateToast(id, "success", "Valor actualizado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al actualizar el valor.");
    return null;
  }
};

export const deleteValue = async (slot_value_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/slots/values/" + bot_id + "/" + slot_value_id);
  if (res[0]) {
    updateToast(id, "success", "Valor eliminado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al eliminar el valor.");
    return null;
  }
};

export const addValue = async (newValueObj) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/slots/values/" + bot_id + "/" + newValueObj.slot_id, newValueObj);
  if (res[0]?.slot_value) {
    updateToast(id, "success", "Valor agregado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al agregar el valor.");
    return null;
  }
};